import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  public Year: string;

  constructor() {
    var today = new Date();
    var yyyy = today.getFullYear();
    this.Year = '' + yyyy;
  }

  ngOnInit() {

    
  }

}
